
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { ShopGoodsInfoDto, isGoodsValid } from '@/api/industryMall'
import PackageSelector from '@/components/PackageSelector/index.vue'
import StepperTemp from '@/components/StepperTemp/index.vue'
import { Getter, Action } from 'vuex-class'
import priceFun from './priceFun.vue'
import {
  updateStoreShoppingCart,
  addStoreShoppingCart
} from '@/api/industryMall'
import store from '@/store'
import { asyncDownloadUrl, downloadUrl } from '@/utils/util'
import PackageSelector1 from '@/views/industryMall/components/PackageSelector/indexCopy1.vue'

@Component({
  name: 'GoodsCard',
  components: { PackageSelector, StepperTemp, priceFun, PackageSelector1 }
})
export default class GoodsCard extends Vue {
  @Action setProviderId: (val: string) => void
  @Getter companyId!: string
  @Getter providerId!: string
  @Getter partnerCompanyId!: string
  @Prop({ default: true }) isUse?: boolean
  @Prop({ default: false }) showAnimation?: boolean // 是否展示动画
  @Prop({ default: () => {} }) data!: ShopGoodsInfoDto

  isAddGoodsDesc = true // 是否添加商品规格
  isSaleWay = true // 是否有销售方式
  specShow = false
  amountIntFormat: string
  amountFloatFormat: string

  @Watch('data')
  dataChange(val) {
    this.specShow = false
    this.getImgBase(this.data.imageUrl)
  }

  mounted () {
    this.getImgBase(this.data.imageUrl)
  }

  activated () {
    this.$set(this.data.packageList[0], 'showKeyboard', false)
  }

  // 获取最小价格
  get minData() {
    let minPrice = 1000000
    let saleUnitWay = ''
    this.data.packageList.map((item,index) => {
      let price = 0
      let jt = item.levelPriceList
      if(jt && jt[0] && jt[0].isStair === 1) {
        // 单规格阶梯定价
        let isScope = false // 是否在区间内
        for (let index = 0; index < jt.length; index++) {
          const element = jt[index]
          if (item.orderQuantity >= element.minAmount && (item.orderQuantity < element.maxAmount || !element.maxAmount)) {
            price = element.finalPrice
            isScope = true
          }
        }
        // if (!isScope) price = Number(item.finalPrice) / item.sellUnit
        if (!isScope) price = Number(item.finalPrice)
        if (item.orderQuantity === 0) price = Number(this.data.goodsPriceMin || '0')
      } else {
        // price = Number(item.finalPrice) / item.sellUnit
        price = Number(item.finalPrice)
      }
      if(price < minPrice) {
        minPrice = price
        saleUnitWay = item.sellUnitWay
      }
    })
    let textPrice = minPrice.toFixed(2)
    return {minPrice:textPrice,saleUnitWay}
  }

  // 是否阶梯定价初始
  get isStairInitial() {
    const result = this.data.packageList.some(i => i.levelPriceList && i.levelPriceList[0] && i.levelPriceList[0].isStair === 1)
    return this.data.packageList[0].orderQuantity === 0 && result
  }

  /**
   * 处理销售方式
   */
  get handleSellDesc() {
    let saleArr = []
    if (this.data.isMultiSpec) {
      saleArr = this.data.packageList.map((item) => {
        return item.packageNameDesc + item.sellUnit + item.sellUnitWay
        // return item.packageNameDesc
      })
    } else {
      saleArr = this.data.packageList.map((item) => {
        return item.sellUnit + item.sellUnitWay
      })
    }
    return saleArr.join('/')
  }

  isActivity() {
    return (this.data.isAddTag === 0 || this.data.isAddTag === 1)
  }

  async getImgBase (url) {
    if (this.data.urlBase) return
    let urlBase = await asyncDownloadUrl(url)
    if (!urlBase) {
      urlBase = downloadUrl(url)
    }
    // console.log('imgElement------', urlBase.slice(0, 50))
    this.$set(this.data, 'urlBase', urlBase)
  }

  handleGoodsValid() {
    this.$emit('reloadList')
  }

  // 进入详情
  toDetail(item: ShopGoodsInfoDto) {
    this.isGoodsValid().then((res) => {
      if (res) {
        this.setProviderId(item.storeId)
        this.$router.push({
          path: '/goodsMallDetail',
          query: {
            goodsId: item.goodsId,
            storeId: item.storeId
          }
        })
      }
    })
  }

  // 校验商品是否已失效/下架
  isGoodsValid() {
    const params = {
      shopId: this.data.storeId,
      goodsId: this.data.goodsId
    }
    return isGoodsValid(params)
      .then((res) => {
        if (res.data.isValid) {
          return true
        } else {
          this.$dialog
            .alert({
              message: '商品过期不存在'
            })
            .then(() => {
              this.$emit('reloadList')
            })
          return false
        }
      })
      .catch(() => {
        return false
      })
  }

  // 更新购物车数量
  changeQuantity(val, e: Event, item) {
    this.$set(this.data.packageList[0], 'showKeyboard', false)
    this.isGoodsValid().then((res) => {
      if (res) {
        if (e && this.showAnimation) {
          this.$shopCarAnimation.show(e)
        }
        if (val < item.sellUnit) {
          val = 0
          item.orderQuantity = 0
        }
        this.updateBuyCar(val)
      }
    })
  }

  showKeyboard (isShow: boolean) {
    this.$set(this.data.packageList[0], 'showKeyboard', isShow)
  }

  // 显示数量添加
  onShowStep(e, item) {
    this.isGoodsValid().then((res) => {
      if (res) {
        if (e && this.showAnimation) {
          this.$shopCarAnimation.show(e)
        }
        this.data.packageList[0].orderQuantity = item.sellUnit || 1
        this.addStoreShoppingCart()
      }
    })
  }

  // 加入购物车
  addStoreShoppingCart() {
    const param = {
      partnerCompanyId: this.partnerCompanyId,
      storeId: this.data.storeId,
      goodsId: this.data.goodsId,
      packageId: this.data.packageList[0].packageId,
      orderQuantity: this.data.packageList[0].orderQuantity
    }
    addStoreShoppingCart(param).then((res:any) => {
      store.dispatch('getShopCarNum', this.partnerCompanyId)
    })
  }

  // 更新购物车
  updateBuyCar(orderQuantity: number) {
    const param = {
      partnerCompanyId: this.partnerCompanyId,
      goodsId: this.data.goodsId,
      packageId: this.data.packageList[0].packageId,
      storeId: this.data.storeId,
      orderQuantity
    }
    updateStoreShoppingCart(param).then((res:any) => {
      store.dispatch('getShopCarNum', this.partnerCompanyId)
    })
  }

  /**
   * 显示多套餐多规格
   */
  onShowSpec() {
    if (this.data.isMultiSpec) {
      this.toDetail(this.data)
    } else {
      this.specShow = !this.specShow
      this.$emit('reloadPage')
    }
  }
  handlePackageSelector () {
    ;(this.$refs.packageSelector as any).show({
      ruleType: 1,
      detailInfo: this.data,
      // selectList: this.selectValueList,
      // defaultInfo: this.defaultDetailInfo,
      // packageList: this.packageList
    })
  }
  // 阻止点击输入数据时的事件冒泡
  handleEmpty() {}
}
